import type { Assign } from '@ark-ui/react'
import type { ark } from '@ark-ui/react'
import { forwardRef } from 'react'
import { Button } from '~/components/button'
import { cn } from '~/utils/cn'
import type { ButtonProps } from '~/components/button'
import type { InputTextSharedProps } from './input-text-root'

export type InputTextClearButtonProps = Assign<
  React.ComponentProps<typeof ark.button>,
  InputTextSharedProps & {
    readOnly?: boolean
    hasError?: boolean
    value?: string
    isActive?: boolean
  }
> &
  Omit<ButtonProps, 'variant' | 'children' | 'className'>

export const InputTextClearButton = forwardRef<
  HTMLButtonElement,
  InputTextClearButtonProps
>(
  (
    {
      size: buttonSize,
      size = 'ml',
      disabled,
      readOnly,
      hasError,
      value,
      isActive,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn('input-text-clear-button', {
          '-mr-[6px]': size === 'md',
          '-mr-[8px]': size === 'ml' || size === 'lg' || size === 'xl',
          'invisible hidden':
            readOnly || disabled || isActive || !value || !value.length,
        })}
        aria-disabled={disabled || readOnly}
      >
        <Button.Root
          {...props}
          size={buttonSize || size}
          disabled={disabled || readOnly}
          variant="neutral-tertiary"
          className={cn('!px-none', {
            '!h-medium !w-medium': size === 'md',
            '!h-mediumlarge !min-w-mediumlarge':
              size === 'ml' || size === 'lg' || size === 'xl',
          })}
        >
          <Button.Icon symbol="rdicon-dismiss-circle-outline" />
        </Button.Root>
      </div>
    )
  }
)

InputTextClearButton.displayName = 'InputTextClearButton'
